<template>
  <div id="kontaktBildBearbeiten" class="text-center">
    <div v-if="kontakteStatus.uploadingContactImage" class="text-center">
      <b-spinner variant="warning" type="grow"></b-spinner>
    </div>
    <div v-else>
      <b-img v-if="kontakt.image" thumbnail fluid :src="`data:${kontakt.contentType};base64,${kontakt.image}`" alt="Bild"></b-img>
      <b-img v-else thumbnail fluid :src="require('@/assets/profile.png')" alt="file 1"></b-img>

      <b-form-file
        v-model="file"
        accept="image/*"
        placeholder="Wählen Sie ein Profilbild"
        class="my-3"
      ></b-form-file>
      <div class="my-2 text-right">
        <b-button @click="$bvModal.hide(`kontaktBearbeiten-${kontakt.id}`)" variant="secondary">Abbrechen</b-button>
        <b-button v-if="file" @click="kontaktBildUpload" variant="warning" class="ml-3">Bild hochladen</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'kontaktBildBearbeiten',
  props: ['kontakt'],
  computed: mapGetters(['kontakteStatus']),
  methods: {
    ...mapActions(['uploadKontaktBild']),
    kontaktBildUpload () {
      var fd = new FormData()
      fd.append('file', this.file)

      this.uploadKontaktBild({kontaktId: this.kontakt.id, file: fd})
        .then(() => {
          const toastData = {
            title: "",
            msg: "Die Änderungen wurden gespeichert.",
            variant: "success"
          };

          if (this.kontakteStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.kontakteStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit('createImageUpdateToast', toastData)

          if (!this.kontakteStatus.errMsg) {
            this.$bvModal.hide(`kontaktBearbeiten-${this.kontakt.id}`)
          }
        })
    }
  },
  data () {
    return {
      file: null
    }
  }
}
</script>
